import * as t from 'io-ts';
import { isUndefined } from 'lodash-es';

import type { CheckBoxDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface ApplyFilterOnSelectionSettingDefinition extends CheckBoxDefinition {
    key: 'APPLY_FILTER_ON_SELECTION';
}

const definition: ApplyFilterOnSelectionSettingDefinition = {
    key: 'APPLY_FILTER_ON_SELECTION',
    type: 'CheckBox',
    label: 'Apply filter on selection',
    value: false,
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.boolean);

export const codec = specSettingsInterface.input;

export const ApplyFilterOnSelectionSettingDefinition = define({
    key: 'APPLY_FILTER_ON_SELECTION',
    label: 'applyFilterOnSelection',
    definition,
    fromSetting: (settings, _, view) =>
        specSettingsInterface.extractValue(settings.applyFilterOnSelection) ??
        // since we want the setting to be present even if not defined on the config,
        // we return the default value (`definition.value`) - unless we are calculating
        // the setting for particular view (returning default value would overwrite the default, which is not what we want)
        (view ? undefined : definition.value),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        isUndefined(settings.applyFilterOnSelection)
            ? // even if setting is not defined, we still want it to be available
              definition
            : specSettingsInterface.createDefinitionWithSettings(settings.applyFilterOnSelection),
});
